import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rma-comparison-table-cell',
  templateUrl: './comparison-table-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'cell',
    class: 'flex w-36 shrink-0 items-center justify-center px-3 py-4 text-center md:min-w-48 md:grow md:basis-0',
  },
})
export class ComparisonTableCellComponent {}
